/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-handler-names */
import React, { useRef, useContext } from 'react';

import { useNavigate } from 'react-router-dom';

import RenderOnTop from '../../../../RenderOnTop';

import classes from './styles.module.scss';
import useOnClickOutside from '../../../../../hooks/useOnClickOutside';
import { CandidatesContext } from '../../../../../context/CandidatesContext';

export default function AddOptionsDropdown({ handleClose }) {
  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, handleClose);

  const navigate = useNavigate();

  const { showIntelCandidateModal } = useContext(CandidatesContext);

  const options = [
    {
      title: 'Post a Job',
      onClick: () => navigate('/tools/jobs/post-job'),
    },
    {
      title: 'Add Candidate',
      onClick: () => {
        showIntelCandidateModal();
      },
    },
  ];

  return (
    <div className={classes.outerContainer}>
      <RenderOnTop
        initialStyle={{
          position: 'absolute',
          top: '55px',
        }}
      >
        <ul className={classes.AddOptionsDropdown} ref={dropdownRef}>
          {options.map((option) => (
            <li
              key={option.title}
              onClick={() => {
                option?.onClick?.();
                handleClose();
              }}
            >
              {option.title}
            </li>
          ))}
        </ul>
      </RenderOnTop>
    </div>
  );
}
